import { checkboxAnatomy as parts } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  defineStyle,
  cssVar,
} from '@chakra-ui/styled-system';
const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const $size = cssVar('checkbox-size');

/** BOT explorer accent — matches verification CTA / links */
const ACCENT = '#14DCAC';
const ACCENT_HOVER = '#12b896';
const ACCENT_ON = '#0A0A0A';

const baseStyleControl = defineStyle({
  _hover: {
    borderColor: ACCENT,
  },
  _focusVisible: {
    boxShadow: `0 0 0 2px ${ ACCENT }`,
  },
  _checked: {
    bg: ACCENT,
    borderColor: ACCENT,
    color: ACCENT_ON,
    _hover: {
      bg: ACCENT_HOVER,
      borderColor: ACCENT_HOVER,
    },
  },
  _indeterminate: {
    bg: ACCENT,
    borderColor: ACCENT,
    color: ACCENT_ON,
    _hover: {
      bg: ACCENT_HOVER,
      borderColor: ACCENT_HOVER,
    },
  },
});

const sizes = {
  sm: definePartsStyle({
    control: { [$size.variable]: 'sizes.3' },
    label: { fontSize: 'sm' },
    icon: { fontSize: '3xs' },
  }),
  md: definePartsStyle({
    control: { [$size.variable]: 'sizes.4' },
    label: { fontSize: 'md' },
    icon: { fontSize: '2xs' },
  }),
  lg: definePartsStyle({
    control: { [$size.variable]: 'sizes.5' },
    label: { fontSize: 'md' },
    icon: { fontSize: '2xs' },
  }),
};

const baseStyleLabel = defineStyle({
  _disabled: { opacity: 0.2 },
});

const baseStyle = definePartsStyle({
  label: baseStyleLabel,
  control: baseStyleControl,
});

const Checkbox = defineMultiStyleConfig({
  baseStyle,
  sizes,
});

export default Checkbox;
